<template>
    <div class="page-block__item">
        <div class="page-block__item-content">
            <div class="layout">
                <div class="layout__item u-1/3-desk">
                    <span class="page-block__item-content-title">
                        {{ trans('hosting.dns') }}
                    </span>
                </div>
                <!--
             -->
                <div class="layout__item u-2/3-desk">
                    <status-label :status="status"/>
                </div>
            </div>
        </div>
        <div class="page-block__item-nav">
            <button @click="enableDns" v-if="customerConfig.dnscontrol === 'OFF'" type="button" class="btn btn--ghost btn--ghost-full-width">
                {{ trans('hosting.settings.dns-enable') }}
            </button>

            <button @click="disableDns" v-if="customerConfig.dnscontrol === 'ON'" type="button" class="btn btn--ghost btn--ghost-full-width">
                {{ trans('hosting.settings.dns-disable') }}
            </button>
        </div>
    </div>
</template>

<script>
import HostingApi from '../services/api/hosting.js';
import { EventBus } from "relapp-event/src/event";
import { StatusLabel } from "relapp-technical-management";

export default {
    components: {
        StatusLabel,
    },
    props: {
        domain: {
            type: String,
            required: true
        },
        customerConfig: {
            type: Object,
            required: true
        }
    },
    methods: {
        enableDns() {
            HostingApi.modifyCustomer(this.domain, { enableDns: true })
                .then(response => {
                    this.customerConfig.dnscontrol = 'ON';

                    EventBus.$emit('notification', {
                        type: 'success',
                        message: trans('action.updated')
                    });
                })
                .catch(function (result) {
                    EventBus.$emit('notification', {
                        type: 'error',
                        message: result.data.message
                    });
                });
        },

        disableDns() {
            HostingApi.modifyCustomer(this.domain, { enableDns: false })
                .then(response => {
                    this.customerConfig.dnscontrol = 'OFF';

                    EventBus.$emit('notification', {
                        type: 'success',
                        message: trans('action.updated')
                    });
                })
                .catch(function (result) {
                    EventBus.$emit('notification', {
                        type: 'error',
                        message: result.data.message
                    });
                });
        },
    },
    computed: {
        /**
         * Status label.
         *
         * @return {string}
         */
        status() {
            if (this.customerConfig.dnscontrol === 'ON') {
                return 'active';
            } else {
                return 'inactive';
            }
        }
    }
};
</script>
